import {i18n} from '@/plugins/i18n'

export const settlementPeriod = {
    EVERY_DAY: 0,
    EVERY_48: 1,
    EVERY_72: 2,
    EVERY_WEEK: 3,
};

export const settlementPeriodStr = {
    EVERY_DAY: i18n.t('settlement_period.every_day'),
    EVERY_48: i18n.t('settlement_period.every_48'),
    EVERY_72: i18n.t('settlement_period.every_72'),
    EVERY_WEEK: i18n.t('settlement_period.every_week'),

    get(type) {
        let str = null;

        Object.keys(settlementPeriod).forEach(item => {
            if (settlementPeriod[item] === type) {
                str = settlementPeriodStr[item];
            }
        });

        return str;
    }
};
